import { ArrowSmRightIcon } from '@heroicons/react/solid'
import { useNavigate } from 'react-router-dom'
import {
  Form,
  LocationInfo,
  Paragraph,
  StickyFooter,
  Title,
} from 'src/components'
import EmailHelpBox from 'src/components/Layout/EmailHelpBox'
import { savedUserGroup } from './storage'
import InputField from 'src/components/Shared/UIComponents/InputField'
import CustomButton from 'src/components/Shared/UIComponents/Button'

const defaultUserGroup = 'mobileconnect'

export default function UserGroup() {
  const navigate = useNavigate()
  const [userGroup, setUserGroup] = savedUserGroup.useState(defaultUserGroup)

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault()
        navigate('../policy')
      }}
    >
      <Title label="User Group" />

      <LocationInfo path="AWS Console/IAM/User groups/Create group" />

      <Paragraph className="col-span-full">
        You'll need to setup a user group named <b>{defaultUserGroup}</b>
      </Paragraph>

      <InputField
        label="user group"
        placeholder="type your user group"
        value={userGroup}
        setValue={setUserGroup}
        disabled
        className="col-span-full"
      />

      <StickyFooter>
        <EmailHelpBox className="flex-1" />
        <CustomButton
          type="submit"
          label="next"
          icon={<ArrowSmRightIcon />}
          iconPosition="right"
        />
      </StickyFooter>
    </Form>
  )
}
